<template>
	<div class="footer">
		<div class="footer-wrap">
			<p>© 2026 张家口分类信息网 版权所有 | 冀ICP备2026013232号-1</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Footer'
	}
</script>

<style lang="scss" scoped>
	.footer {
		background: #f5f5f5;
		padding: 20px 0;
		text-align: center;
		color: #666;
		margin-top: 30px;
	}
</style>